export type PrinterStatusLevel = 'ok' | 'warning' | 'error' | 'unknown';

const ERROR_WORDS = [
  'jam',
  'offline',
  'error',
  'fault',
  'unavailable',
  'not_available',
  'out_of_paper',
  'no_paper',
  'door',
];
const WARNING_WORDS = ['low', 'paused', 'pause', 'warning', 'busy', 'user_intervention', 'ribbon'];
const OK_WORDS = ['ok', 'ready', 'idle', 'online', 'printing', 'processing', 'complete'];

/**
 * QZ Tray forwards the status text of the OS / print system (Windows spooler, CUPS...), whose wording differs
 * from one OS to another: classify it by keywords and keep anything unknown neutral instead of guessing.
 */
export const classifyPrinterStatus = (status?: string | null): PrinterStatusLevel => {
  if (!status) {
    return 'unknown';
  }
  const text = status.toLowerCase();
  if (ERROR_WORDS.some((word) => text.includes(word))) {
    return 'error';
  }
  if (WARNING_WORDS.some((word) => text.includes(word))) {
    return 'warning';
  }
  if (OK_WORDS.some((word) => text === word || text.includes(word))) {
    return 'ok';
  }
  return 'unknown';
};
